module.exports = __webpack_public_path__ + "img/03-B09.3a914c0c.png";